import React, { useState } from "react";
import PropTypes from "prop-types";


const PasswordInput = ({
  name,
  title,
  type,
  value,
  error,
  handleChange,
  placeholder,
  className,
}) => {
  const [visibility, setVisibility] = useState({ [`${name}`]: "" });

  return (
    <div className="mb-2 text-start">
      {title && (
        <label className="d-flex align-items-center fs-12 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}

      <div className="password-container position-relative">
        {/* Pre-icon inside input on left */}
        <span className="position-absolute top-50 start-0 translate-middle-y ps-3">
          <i className="bi bi-lock-fill text-muted"></i>
        </span>

        {/* Input with padding on both sides */}
        <input
          id="password"
          type={visibility[name] ? "text" : "password"}
          className={
            className
              ? className
              : "form-control password-input form-control-solid ps-5 pe-5"
          }
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            handleChange(e);
          }}
        />

        {/* Toggle icon on right */}
        <span
          className="position-absolute top-50 end-0 translate-middle-y pe-3"
          onClick={() =>
            setVisibility((prev) => ({ ...prev, [name]: !visibility[name] }))
          }
          style={{ cursor: "pointer" }}
        >
          {visibility[name] ? (
            <i className="bi bi-eye-fill text-muted"></i>
          ) : (
            <i className="bi bi-eye-slash-fill text-muted"></i>
          )}
        </span>
      </div>

      <span className="fs-10 text-danger ps-3">{error}</span>
    </div>
  );
};

PasswordInput.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};
export default PasswordInput;
